import { useEffect, useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord, RemoveRedEyeOutlined } from "@mui/icons-material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
// import { routeName } from "../../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { StudentApi } from "../../../../api/student/student.api";
import { dateToView } from "../../../../utils/date.utils";

const VisaInfo = ({
  student_id,
  // student_data,
}: {
  student_id: number;
  student_data: any;
}) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();

  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getVisa = async (student_id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    const res = await StudentApi.fetchGetVisaList(student_id, query);
    const data = res.data;
    if (data.status < 300) {
      // setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setData(data.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (student_id) {
      getVisa(student_id);
    }
  }, [page, pageLimit, sortBy, sortType, student_id]);

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 15,
      disablePadding: false,
      align: "start",
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.FULLNAME_COLUMN"),
    },
    {
      id: "visa_no",
      disablePadding: false,
      width: 15,
      align: "center",
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.VISA_NO_COLUMN"),
    },
    {
      id: "visa_type",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.VISA_TYPE_COLUMN"),
    },
    {
      id: "visa_issue_date",
      disablePadding: false,
      align: "center",
      width: 10,
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.VISA_ISSUE_DATE_COLUMN"),
    },
    {
      id: "visa_expiry_date",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.VISA_EXPIRY_DATE_COLUMN"),
    },
    {
      id: "visa_status",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t("STUDENT_MANAGEMENT.VISA_INFO.TABLE.VISA_STATUS_COLUMN"),
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id,
      fullname,
      passport,
      type_visa,
      visa_issue_date,
      visa_expiration_date,
      status,
    } = objData;

    const objRenderData = {
      key: id,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${fullname ?? "-"}`,
        },
        {
          option: "TEXT",
          align: "center",
          label: passport || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: type_visa || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: visa_issue_date ? dateToView(visa_issue_date, false) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: visa_expiration_date
            ? dateToView(visa_expiration_date, false)
            : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={status}
              type="outlined"
              color="success"
              icon={<FiberManualRecord />}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  return (
    <section className="w-full mt-10">
      <TableCustom
        tableMinWidth={1440}
        tableFixedWidth
        customScroll
        page={page}
        pageLimit={pageLimit}
        sortBy={sortBy}
        sortType={sortType}
        headCells={headCells}
        rowCount={totalItems}
        rowsData={
          data &&
          data.length > 0 &&
          data.map((data: any, i: any) => {
            return renderData(data, i);
          })
        }
        onSort={handleRequestSort}
        setPageLimit={(value: number) => setPageLimit(value)}
        setPage={(value: number) => setPage(value)}
      />
    </section>
  );
};

export default VisaInfo;
